
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
:host {
  --grid-gutter-x: 24px;
  --grid-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--grid-gutter-y) * -1);
  margin-right: calc(var(--grid-gutter-x) * -0.5);
  margin-left: calc(var(--grid-gutter-x) * -0.5);
  box-sizing: border-box;
}
:host slot.grid-row-wrapper {
  width: 100%;
}

:host([align=start]) {
  align-items: flex-start !important;
}

:host([align=end]) {
  align-items: flex-end !important;
}

:host([align=center]) {
  align-items: center !important;
}

:host([align=baseline]) {
  align-items: baseline !important;
}

:host([align=stretch]) {
  align-items: stretch !important;
}

:host([align-content=start]) {
  align-content: flex-start !important;
}

:host([align-content=end]) {
  align-content: flex-end !important;
}

:host([align-content=center]) {
  align-content: center !important;
}

:host([align-content=between]) {
  align-content: space-between !important;
}

:host([align-content=around]) {
  align-content: space-around !important;
}

:host([align-content=stretch]) {
  align-content: stretch !important;
}

:host([justify=start]) {
  justify-content: flex-start !important;
}

:host([justify=end]) {
  justify-content: flex-end !important;
}

:host([justify=center]) {
  justify-content: center !important;
}

:host([justify=between]) {
  justify-content: space-between !important;
}

:host([justify=around]) {
  justify-content: space-around !important;
}

:host([justify=evenly]) {
  justify-content: space-evenly !important;
}

@media (min-width: 560px) {
  :host([align-sm=start]) {
    align-items: flex-start !important;
  }
  :host([align-sm=end]) {
    align-items: flex-end !important;
  }
  :host([align-sm=center]) {
    align-items: center !important;
  }
  :host([align-sm=baseline]) {
    align-items: baseline !important;
  }
  :host([align-sm=stretch]) {
    align-items: stretch !important;
  }
  :host([align-content-sm=start]) {
    align-content: flex-start !important;
  }
  :host([align-content-sm=end]) {
    align-content: flex-end !important;
  }
  :host([align-content-sm=center]) {
    align-content: center !important;
  }
  :host([align-content-sm=between]) {
    align-content: space-between !important;
  }
  :host([align-content-sm=around]) {
    align-content: space-around !important;
  }
  :host([align-content-sm=stretch]) {
    align-content: stretch !important;
  }
  :host([justify-sm=start]) {
    justify-content: flex-start !important;
  }
  :host([justify-sm=end]) {
    justify-content: flex-end !important;
  }
  :host([justify-sm=center]) {
    justify-content: center !important;
  }
  :host([justify-sm=between]) {
    justify-content: space-between !important;
  }
  :host([justify-sm=around]) {
    justify-content: space-around !important;
  }
  :host([justify-sm=evenly]) {
    justify-content: space-evenly !important;
  }
}
@media (min-width: 768px) {
  :host([align-md=start]) {
    align-items: flex-start !important;
  }
  :host([align-md=end]) {
    align-items: flex-end !important;
  }
  :host([align-md=center]) {
    align-items: center !important;
  }
  :host([align-md=baseline]) {
    align-items: baseline !important;
  }
  :host([align-md=stretch]) {
    align-items: stretch !important;
  }
  :host([align-content-md=start]) {
    align-content: flex-start !important;
  }
  :host([align-content-md=end]) {
    align-content: flex-end !important;
  }
  :host([align-content-md=center]) {
    align-content: center !important;
  }
  :host([align-content-md=between]) {
    align-content: space-between !important;
  }
  :host([align-content-md=around]) {
    align-content: space-around !important;
  }
  :host([align-content-md=stretch]) {
    align-content: stretch !important;
  }
  :host([justify-md=start]) {
    justify-content: flex-start !important;
  }
  :host([justify-md=end]) {
    justify-content: flex-end !important;
  }
  :host([justify-md=center]) {
    justify-content: center !important;
  }
  :host([justify-md=between]) {
    justify-content: space-between !important;
  }
  :host([justify-md=around]) {
    justify-content: space-around !important;
  }
  :host([justify-md=evenly]) {
    justify-content: space-evenly !important;
  }
}
@media (min-width: 992px) {
  :host([align-lg=start]) {
    align-items: flex-start !important;
  }
  :host([align-lg=end]) {
    align-items: flex-end !important;
  }
  :host([align-lg=center]) {
    align-items: center !important;
  }
  :host([align-lg=baseline]) {
    align-items: baseline !important;
  }
  :host([align-lg=stretch]) {
    align-items: stretch !important;
  }
  :host([align-content-lg=start]) {
    align-content: flex-start !important;
  }
  :host([align-content-lg=end]) {
    align-content: flex-end !important;
  }
  :host([align-content-lg=center]) {
    align-content: center !important;
  }
  :host([align-content-lg=between]) {
    align-content: space-between !important;
  }
  :host([align-content-lg=around]) {
    align-content: space-around !important;
  }
  :host([align-content-lg=stretch]) {
    align-content: stretch !important;
  }
  :host([justify-lg=start]) {
    justify-content: flex-start !important;
  }
  :host([justify-lg=end]) {
    justify-content: flex-end !important;
  }
  :host([justify-lg=center]) {
    justify-content: center !important;
  }
  :host([justify-lg=between]) {
    justify-content: space-between !important;
  }
  :host([justify-lg=around]) {
    justify-content: space-around !important;
  }
  :host([justify-lg=evenly]) {
    justify-content: space-evenly !important;
  }
}
@media (min-width: 1200px) {
  :host([align-xl=start]) {
    align-items: flex-start !important;
  }
  :host([align-xl=end]) {
    align-items: flex-end !important;
  }
  :host([align-xl=center]) {
    align-items: center !important;
  }
  :host([align-xl=baseline]) {
    align-items: baseline !important;
  }
  :host([align-xl=stretch]) {
    align-items: stretch !important;
  }
  :host([align-content-xl=start]) {
    align-content: flex-start !important;
  }
  :host([align-content-xl=end]) {
    align-content: flex-end !important;
  }
  :host([align-content-xl=center]) {
    align-content: center !important;
  }
  :host([align-content-xl=between]) {
    align-content: space-between !important;
  }
  :host([align-content-xl=around]) {
    align-content: space-around !important;
  }
  :host([align-content-xl=stretch]) {
    align-content: stretch !important;
  }
  :host([justify-xl=start]) {
    justify-content: flex-start !important;
  }
  :host([justify-xl=end]) {
    justify-content: flex-end !important;
  }
  :host([justify-xl=center]) {
    justify-content: center !important;
  }
  :host([justify-xl=between]) {
    justify-content: space-between !important;
  }
  :host([justify-xl=around]) {
    justify-content: space-around !important;
  }
  :host([justify-xl=evenly]) {
    justify-content: space-evenly !important;
  }
}
@media (min-width: 1400px) {
  :host([align-xxl=start]) {
    align-items: flex-start !important;
  }
  :host([align-xxl=end]) {
    align-items: flex-end !important;
  }
  :host([align-xxl=center]) {
    align-items: center !important;
  }
  :host([align-xxl=baseline]) {
    align-items: baseline !important;
  }
  :host([align-xxl=stretch]) {
    align-items: stretch !important;
  }
  :host([align-content-xxl=start]) {
    align-content: flex-start !important;
  }
  :host([align-content-xxl=end]) {
    align-content: flex-end !important;
  }
  :host([align-content-xxl=center]) {
    align-content: center !important;
  }
  :host([align-content-xxl=between]) {
    align-content: space-between !important;
  }
  :host([align-content-xxl=around]) {
    align-content: space-around !important;
  }
  :host([align-content-xxl=stretch]) {
    align-content: stretch !important;
  }
  :host([justify-xxl=start]) {
    justify-content: flex-start !important;
  }
  :host([justify-xxl=end]) {
    justify-content: flex-end !important;
  }
  :host([justify-xxl=center]) {
    justify-content: center !important;
  }
  :host([justify-xxl=between]) {
    justify-content: space-between !important;
  }
  :host([justify-xxl=around]) {
    justify-content: space-around !important;
  }
  :host([justify-xxl=evenly]) {
    justify-content: space-evenly !important;
  }
}
`;
